import React from "react";
import styled from "@emotion/styled";

const VideoContainer = styled.div`
  margin: 2em auto;
  display: grid;
  gap: 1em;
  .title-gallery {
    font-size: 2em;
    font-weight: 900;
    margin: 0.8em 0em;
  }
`;

const LandscapeVideo = ({ slice }) => {
  return (
    <>
      {slice.items.map((object, index) => (
        <video
          key={index}
          loading="lazy"
          autoPlay
          muted
          loop
          playsInline
          style={{
            border: "1px solid rgba(64, 87, 109, 0.07)",
            borderRadius: "0.5em",
            display: "block",
            width: "100%",
            margin: "0 auto",
            height: "auto",
          }}
        >
          <source src={object.video_media.url} type="video/mp4" />
        </video>
      ))}
    </>
  );
};
const DefaultVideo = ({ slice }) => {
  return (
    <>
      {slice.items.map((object, index) => (
        <video
          key={index}
          loading="lazy"
          autoPlay
          muted
          loop
          playsInline
          style={{
            border: "1px solid rgba(64, 87, 109, 0.07)",
            borderRadius: "0.5em",
            display: "block",
            width: "100%",
            maxWidth: 300,
            margin: "0 auto",
            height: "auto",
          }}
        >
          <source src={object.video_media.url} type="video/mp4" />
        </video>
      ))}
    </>
  );
};
const renderSwitch = (slice) => {
  switch (slice.slice_label) {
    case "landscape":
      return <LandscapeVideo slice={slice} />;
    default:
      return <DefaultVideo slice={slice} />;
  }
};

const VideoMedia = ({ slice }) => {
  return <VideoContainer>{renderSwitch(slice)}</VideoContainer>;
};

export default VideoMedia;
